/* eslint-disable linebreak-style */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Route, Switch } from 'react-router-dom';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';



import Snackbar from '@material-ui/core/Snackbar';
import ReactGA from 'react-ga';

import './App.css';
import './config/setYupLocale';
import './config/setMomentLocale';
import { checkAuth, auth, resetPassword, newPassword, authEmployee } from './store/actions/auth';
import { clearMessage } from './store/actions/general';
import { registerEmployee } from './store/actions/clockInOut';
import { toggleChat } from './store/actions/chat';


import withRoot from './hoc/withRoot';
import Dashboard from './routes/Dashboard';
import Login from './components/Login/Login';
import NotFound from './components/NotFound/NotFound';
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import NewPassword from './components/NewPassword/NewPassword';
import ClockInOut from './containers/ClockInOut/ClockInOut';
import RegisterEmployee from './components/Register/RegisterEmployee';
import EmailConfirmation from './components/EmailConfirmation/EmailConfirmation';
import EmployeeWeb from './containers/EmployeeWeb/Employee';
import PremiumPayment from './components/PremiumPayment/view';
import Logout from './containers/Logout/Logout';

// ReactGA.initialize('UA-132198452-2');
// ReactGA.pageview(window.location.pathname + window.location.search);
if (window.location.host.indexOf('appdev') === -1) {
  console.log('production running.');
  ReactGA.initialize('UA-132198452-2');
  ReactGA.pageview(window.location.pathname + window.location.search);
} else {
  console.log('development running.');
}

class App extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };
  constructor(props) {
    super(props);

    const { cookies } = props;
    const cookie = cookies.get('punto-info');
    let params = new URLSearchParams(window.location.search);
    // console.log('cookie', params.get('token'))
    // console.log(window.location.search);
    if (cookie) {
      localStorage.setItem('token', cookie.token);
      localStorage.setItem('companyCode', cookie.companyCode);
      localStorage.setItem('socialName', cookie.socialName);
      localStorage.setItem('userName', cookie.userName);
      localStorage.setItem('companies', cookie.companies || JSON.stringify([]));
      localStorage.setItem('warningPre', false);
    } else if (params.get('token')) {
      localStorage.setItem('token', params.get('token'));
      localStorage.setItem('companyCode', params.get('companyCode'));
      localStorage.setItem('socialName', params.get('socialName'));
      localStorage.setItem('userName', params.get('userName'));
      localStorage.setItem('companies', params.get('companies') || JSON.stringify([]));
      localStorage.setItem('warningPre', false);
      const privileges = {
        "isExportAfd": true
      }
      localStorage.setItem("privileges", JSON.stringify(privileges));

      let url = new URL(window.location.href);

      // Remova os parâmetros que você não quer mais
      url.searchParams.delete('token');
      url.searchParams.delete('companyCode');
      url.searchParams.delete('socialName');
      url.searchParams.delete('userName');
      url.searchParams.delete('companies');

      // Atualize a URL sem recarregar a página
      window.history.replaceState({}, null, url.toString());
    }

    cookies.remove('punto-info', { path: '/', domain: '.puntu.com.br' });
    cookies.remove('punto-info', { path: '/', domain: '.puntu.app' });
    cookies.remove('punto-info', { path: '/', domain: '.puntu.digital' });
  }
  state = {
    snackOpen: true,
  };

  componentWillMount() {
    this.props.tryAutoSignIn();
  }

  handleSnackClose = () => {
    this.setState({ snackOpen: false });
  };

  handleSnackExited = () => {
    this.props.onClearMessage();
    this.setState({ snackOpen: true });
  };

  render() {
    const {
      isAuth,
      isEmployee,
      onAuth,
      loading,
      message,
      onResetPassword,
      onNewPassword,
      onRegisterEmployee,
      onAuthEmployee,
    } = this.props;

    let routes = (
      <Route
        path="(/login/|):optionalPath?"
        render={props => (
          <Login
            {...props}
            authEmployee={onAuthEmployee}
            onAuth={onAuth}
            loading={loading}
            isCompanyAuth={isAuth && isEmployee !== 'true'}
          />
        )}
      />
    );

    if (window.location.pathname == '/cadastro') {
      routes = (
        <>
          <PremiumPayment />
        </>
      );
    }

    if (isAuth && isEmployee !== 'true') {
      routes = <Dashboard />;
    }

    if (isAuth && isEmployee === 'true') {
      routes = (
        <>
          <Route path="/logout/:optionalPath?" component={Logout} />
          <Route path="/" render={() => <EmployeeWeb />} />
        </>
      );
    }

    return (
      <div className="App">
        <Switch>
          <Route path="/ponto-web" component={ClockInOut} />
          <Route
            path="/esqueceu-senha"
            render={props => (
              <ForgotPassword {...props} onResetPassword={onResetPassword} loading={loading} />
            )}
          />
          <Route
            path="/nova-senha/:token"
            render={() => <NewPassword onNewPassword={onNewPassword} loading={loading} />}
          />
          <Route path="/cadastro?plan=light&Anual=false" render={() => <PremiumPayment />} />
          <Route
            path="/registrar-empregado/:code?"
            render={props => <RegisterEmployee params={props.match.params} onRegisterEmployee={onRegisterEmployee} loading={loading} />}
          />
          <Route path="/login/:optionalPath?" render={props => <Login {...props} authEmployee={onAuthEmployee} onAuth={onAuth} loading={loading} isCompanyAuth={isAuth && isEmployee !== 'true'} />} />
          <Route path="/email-confirmation/:code" component={EmailConfirmation} />
          {routes}
          <Route component={NotFound} />
        </Switch>

        {/* <Chat openChat={isAuth} companyCode={companyCode} socialName={socialName} chat={chat}/> */}
        {/* {Chat(chat)} */}
        {toggleChat(isAuth)}


        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          open={message && this.state.snackOpen}
          onClose={this.handleSnackClose}
          onExited={this.handleSnackExited}
          autoHideDuration={4000}
          message={<span id="message-id">{message}</span>}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isAuth: state.auth.token !== null,
  isEmployee: `${state.auth.isEmployee}`,
  message: state.general.message,
  loading: state.general.loading,
  companyCode: state.auth.companyCode,
  socialName: state.auth.socialName,
});

const mapDispatchToProps = dispatch => ({
  onAuth: (data, isLogin) => dispatch(auth(data, isLogin)),
  onAuthEmployee: data => dispatch(authEmployee(data)),
  tryAutoSignIn: () => dispatch(checkAuth()),
  onClearMessage: () => dispatch(clearMessage()),
  onResetPassword: email => dispatch(resetPassword(email)),
  onNewPassword: (password, token) => dispatch(newPassword(password, token)),
  onRegisterEmployee: employee => dispatch(registerEmployee(employee)),
});

export default withCookies(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRoot(App))));

